import React from 'react'

function Column444Icon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="46"
      height="34"
      viewBox="0 0 46 34"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <polygon points="33.9138461 0.5 33.9138461 33.9138461 45.0517948 33.9138461 45.0517948 0.5" />
      <polygon points="17.206923 0.5 17.206923 33.9138461 28.3448717 33.9138461 28.3448717 0.5" />
      <polygon points="0.5 0.5 0.5 33.9138461 11.6379487 33.9138461 11.6379487 0.5" />
    </svg>
  )
}

export default Column444Icon
